module.exports = __webpack_public_path__ + "assets/img/feature-visual-1.9d853383.png";